import { useQuery } from "react-query";
import { GET_CAREGIVER_INVOLVEMENT, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";
import { getCaregiverInvolvement } from "api/clinicalManagement";
import extractRecords from "../utils/extractRecords";

export type CaregiverInvolvementRecord = Record<string, unknown>;

const useGetCaregiverInvolvement = (clientId: number | null) => {
  const { data, isLoading, refetch, ...rest } = useQuery(
    [GET_CAREGIVER_INVOLVEMENT, clientId],
    () => getCaregiverInvolvement(clientId),
    {
      staleTime: STALE_TIME_5_MINUTES,
      enabled: Boolean(clientId),
      refetchOnWindowFocus: false,
    }
  );

  const records = extractRecords<CaregiverInvolvementRecord>(data);

  const caregiverInvolvement = records.length > 0 ? records[0] : null;

  return {
    caregiverInvolvement,
    caregiverInvolvementLoading: isLoading,
    refetchCaregiverInvolvement: refetch,
    ...rest,
  };
};

export default useGetCaregiverInvolvement;
